export default () => {
  // https://chanind.github.io/javascript/2019/09/28/avoid-100vh-on-mobile-web.html
  const wrapper = document.querySelector('.wrapper--interface, .wrapper--signup')
  if (wrapper !== null) {
    wrapper.style.minHeight = window.innerHeight + 'px'
  }
}